import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary"]
  static values = { stateKey: String }

  connect() {
    this.expanded = this.element.open
    this.shell = this.element.closest(".operator-shell")
    this.rail = Boolean(this.shell?.classList.contains("is-collapsed"))
    if (this.hasStateKeyValue) {
      try {
        const saved = window.sessionStorage.getItem(this.storageKey)
        if (saved === "true" || saved === "false") this.expanded = saved === "true"
      } catch { /* Storage restrictions must not prevent menu use. */ }
      this.remember()
    }
    this.element.open = this.rail || this.expanded
  }

  railChanged(event) {
    if (event.target !== this.shell) return
    this.rail = event.detail.collapsed
    this.settle()
  }

  get storageKey() { return `car-nexa:navigation:${this.stateKeyValue}` }

  remember() {
    if (!this.hasStateKeyValue) return
    try { window.sessionStorage.setItem(this.storageKey, String(this.expanded)) }
    catch { /* Keep normal details behavior when storage is unavailable. */ }
  }

  toggle(event) {
    event.preventDefault()
    const startHeight = this.element.getBoundingClientRect().height
    this.stopAnimation()
    this.expanded = !this.expanded
    this.remember()

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !this.element.animate) {
      this.element.open = this.expanded
      return
    }

    // Measure the native final box, including summary margins and group separators.
    // Restore open synchronously so closing children stay visible until completion.
    this.element.open = this.expanded
    const endHeight = this.element.getBoundingClientRect().height
    this.element.open = true
    this.element.classList.add("is-animating")
    const animation = this.element.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 220, easing: "ease-in-out", fill: "both" }
    )
    this.animation = animation
    animation.onfinish = () => {
      this.element.open = this.expanded
      this.stopAnimation()
    }
  }

  stopAnimation() {
    if (this.animation) {
      this.animation.onfinish = null
      this.animation.cancel()
      this.animation = null
    }
    this.element.classList.remove("is-animating")
  }

  settle() {
    this.stopAnimation()
    this.element.open = this.rail || this.expanded
  }

  disconnect() { this.settle() }
}
